module.exports = __webpack_public_path__ + "img/editor-token.649dc66c.svg";